import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Logo from "./sub-components/Logo";
import IconGroup from "./sub-components/IconGroup";
import MobileMenu from "./sub-components/mobile-menu/MobileMenu";
import HeaderTop from "./sub-components/HeaderTop";
import {
    setActiveLayout
} from "../../product";
import {
    SwipeableDrawer,
    Button
} from "@material-ui/core";
import {
    multilanguage
} from "redux-multilanguage";
import { connect } from 'react-redux';
import {
    onChangeFilter,
    clearFilter,
    getProducts
} from "../../../redux/actions/shopPageActions";
import NavMenu from "./sub-components/NavMenu";
import { useLocation } from "react-router-dom";

const Header = ({
    strings,
    layout,
    top,
    borderStyle,
    headerPaddingClass,
    headerPositionClass,
    headerBgClass,
    shopLayout,
    getLayout,
    showActions,
    categories,
    uniqueProducts,
    colors,
    currentLanguageCode,
    onChangeFilter,
    shopPage,
    home,
    getProducts,
    clearFilter
}) => {
    const [scroll, setScroll] = useState(0);
    const [headerTop, setHeaderTop] = useState(0);
    const [openMenu, toggleDrawer] = useState(false);
    let query = new URLSearchParams(useLocation().search);
    const location = useLocation();
    const { pathname } = location;

    useEffect(() => {
        if (pathname !== "/shop") {
            getProducts(query);
        }
        const header = document.querySelector(".sticky-bar");
        setHeaderTop(header.offsetTop);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = () => {
        setScroll(window.scrollY);
    };

    return (
        <header
            className={`header-area clearfix ${headerBgClass ? headerBgClass : ""} ${headerPositionClass ? headerPositionClass : ""
                }`}
        >
            <div
                className={`${headerPaddingClass ? headerPaddingClass : ""} ${top === "visible" ? "d-none d-lg-block" : "d-none"
                    } header-top-area ${borderStyle === "fluid-border" ? "border-none" : ""
                    }`}
            >
                <div className={layout === "container-fluid" ? layout : "container"}>
                    {/* header top */}
                    <HeaderTop borderStyle={borderStyle} />
                </div>
            </div>

            <div
                className={` ${headerPaddingClass ? headerPaddingClass : ""
                    } sticky-bar header-res-padding clearfix ${scroll > headerTop ? "stick" : ""
                    }`}
            >
                <div className={layout === "container-fluid" ? layout : "container"}>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-6 col-4">
                            {/* header logo */}
                            <Logo imageUrl="/assets/img/logo/iola_logo.svg" logoClass="logo iola-logo" />
                        </div>
                        <div className="col-xl-8 col-lg-8 d-none d-lg-block">
                            {/* Nav menu */}

                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }} className="col-xl-2 col-lg-2 col-md-6 col-8">
                            {/* Icon group */}
                            <IconGroup />
                        </div>
                    </div>
                    <div className="row d-none d-lg-block">
                        <NavMenu products={shopPage.uniqueProducts} categories={shopPage.categories} />
                    </div>

                </div>
                {/* mobile menu */}
                <MobileMenu />
                {
                    showActions ?
                        <div style={{ height: 50, display: "flex", alignItems: "center" }} className="shop-top-bar pt-35">
                            <div style={{ marginLeft: 15 }} className="shop-tab">
                                <button
                                    className={shopLayout === "grid two-column" ? "active" : ""}
                                    onClick={e => {
                                        getLayout("grid two-column");
                                        setActiveLayout(e);
                                    }}
                                >
                                    <i className="fa fa-th-large" />
                                </button>
                                <button
                                    className={shopLayout === "grid three-column" ? "active" : ""}
                                    onClick={e => {
                                        getLayout("grid three-column");
                                        setActiveLayout(e);
                                    }}
                                >
                                    <i className="fa fa-th" />
                                </button>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center", width: "65%" }} className="shop-tab">
                                <button style={{ height: 50, width: 50 }} onClick={() => toggleDrawer(true)}><i style={{ color: "#333" }} className="pe-7s-filter" /></button>
                                <SwipeableDrawer
                                    anchor="top"
                                    open={openMenu}
                                    onClose={() => toggleDrawer(false)}
                                    onOpen={() => toggleDrawer(true)}
                                >
                                    <div>
                                        <button onClick={() => toggleDrawer(false)} style={{ justifyContent: "center", alignItems: "center", display: "flex", float: "right", background: "none", border: "none", marginTop: 10, marginBottom: 25 }}>
                                            <i style={{ fontSize: "larger" }} className="fa fa-close"></i>
                                        </button>
                                        <div style={{ padding: "30px 20px 35px 20px" }}>
                                            <div className="form-group">
                                                <label>{strings['product']['price']}</label>
                                                <select
                                                    value={shopPage.selectedFilterValue}
                                                    onChange={e => onChangeFilter("selectedFilterValue", e.target.value, "price")}
                                                    className="form-control">
                                                    <option value="default">{strings['product']['default']}</option>
                                                    <option value="priceHighToLow">{strings['product']['highToLow']}</option>
                                                    <option value="priceLowToHigh">{strings['product']['lowToHigh']}</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>{strings['product']['categories']}</label>
                                                <select
                                                    value={shopPage.selectedCategory}
                                                    onChange={e => onChangeFilter("selectedCategory", e.target.value, "category")}
                                                    className="form-control">
                                                    <option value="all">{strings['product']['allCategories']}</option>
                                                    {
                                                        categories.map((item, i) => {
                                                            return <option key={i} value={item.categoryCode}>{item.categoryName[currentLanguageCode]}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>{strings['product']['color']}</label>
                                                <select
                                                    value={shopPage.selectedColor}
                                                    onChange={e => onChangeFilter("selectedColor", e.target.value, "color")}
                                                    className="form-control">
                                                    <option value="all">{strings['product']['allColors']}</option>
                                                    {
                                                        colors.map((item, i) => {
                                                            return <option key={i} value={item.colorCode}>{item.colorName}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>{strings['product']['product']}</label>
                                                <select
                                                    value={shopPage.selectedProduct}
                                                    onChange={e => onChangeFilter("selectedProduct", e.target.value, "product")}
                                                    className="form-control">
                                                    <option value="all">{strings['product']['allProducts']}</option>
                                                    {
                                                        uniqueProducts.map((item, i) => {
                                                            return <option key={i} value={item.seoName}>{item.productName[currentLanguageCode]}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: 25 }}>
                                                <Button style={{ fontFamily: "Arquitecta, sans-serif" }} variant="contained" onClick={() => clearFilter()} >
                                                    {strings['product']['clear']}
                                                </Button>
                                                <Button style={{ fontFamily: "Arquitecta, sans-serif" }} variant="contained" onClick={() => toggleDrawer(false)}>
                                                    {strings['product']['ok']}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </SwipeableDrawer>
                            </div>
                        </div> : null

                }
            </div>
        </header>
    );
};

Header.propTypes = {
    borderStyle: PropTypes.string,
    headerPaddingClass: PropTypes.string,
    headerPositionClass: PropTypes.string,
    layout: PropTypes.string,
    top: PropTypes.string
};

const mapStateToProps = state => {
    return {
        shopPage: state.shopPage,
        home: state.home
    }
}

export default connect(mapStateToProps, {
    onChangeFilter,
    clearFilter,
    getProducts
})(multilanguage(Header));